/**
 * Initialize all sub-modules
 */
jQuery(function($) {
	var helper = require('../commons/helper');

	var modules = {
		reference: require('./reference'),
	};

	// params is supposed to be defined in the page.
	helper.initPage({
		modules: modules
	});
});






//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/product/product.js
// module id = 247
// module chunks = 6